var map = {
	"./app_strings.json": 84770,
	"./client/account_client.json": 93061,
	"./client/common_client.json": 31670,
	"./client/console.json": 944,
	"./client/consultation_client.json": 74363,
	"./client/eyes.json": 91511,
	"./client/nav_client.json": 11425,
	"./client/patient_client.json": 50658,
	"./client/pdf.json": 578,
	"./client/stats_client.json": 21283
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 64961;